import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import '../styles/footer.css';

class Footer extends Component {
  render() {
    const { t } = this.context;
    const { hideRiskDisclaimer } = this.props;

    return (
      <div className="footer-container">
        <p>{t('FOOTER.FIRST_SENTENCE')}</p>
        {!hideRiskDisclaimer && <p>{t('FOOTER.SECOND_SENTENCE', { year: moment().format('YYYY') })}</p>}
      </div>
    );
  }
}

Footer.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/app/shared/footer/components/footer.js